exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".default-project-setting-form {\n  width: 75%;\n  float: right;\n  position: relative; }\n\n.default-project-warehouse-setting-form {\n  width: 75%;\n  float: right;\n  position: relative; }\n\n.default-project-acting-as-an-agent-check-box {\n  margin-right: 7.5em;\n  left: 1%;\n  float: right; }\n", ""]);

